import React, {useState} from "react";
import {Outlet, useLocation, useNavigate} from "react-router-dom";
import Sidebar from "./Sidebar";
import {useAuth} from "../Context/AuthContext";

const DashboardLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();
    const {user, getToken} = useAuth();

    // Close sidebar when route changes on mobile
    React.useEffect(() => {
        setSidebarOpen(false);
    }, [location.pathname]);

    // Auth guard: redirect to login if no token
    React.useEffect(() => {
        const token = getToken?.();
        if (!token) {
            navigate('/center/login', {replace: true});
        }
    }, [getToken, navigate, location.pathname]);

    return (
        <div className="flex h-screen bg-gray-900">
            {/* Sidebar */}
            <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)}/>

            {/* Main Content */}
            <div className="flex-1 flex flex-col overflow-hidden">
                {/* Top Navigation Bar */}
                <header className="bg-gray-800 shadow-lg border-b border-gray-700 px-4 py-3">
                    <div className="flex items-center justify-between">
                        {/* Mobile menu button */}
                        <button
                            onClick={() => setSidebarOpen(true)}
                            className="lg:hidden p-2 rounded-md text-gray-400 hover:text-white hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-purple-500"
                        >
                            <svg
                                className="h-6 w-6"
                                fill="none"
                                viewBox="0 0 24 24"
                                stroke="currentColor"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M4 6h16M4 12h16M4 18h16"
                                />
                            </svg>
                        </button>

                        {/* Page Title */}
                        <div className="flex-1 text-center lg:text-left">
                            <h1 className="text-xl font-semibold text-white">
                                {location.pathname.includes("/analytics")
                                    ? "Analytics"
                                    : location.pathname.includes("/seller")
                                        ? "Seller Dashboard"
                                        : location.pathname.includes("/charts")
                                            ? "Charts"
                                            : "Dashboard"}
                            </h1>
                        </div>

                        {/* User Profile */}
                        <div className="flex items-center space-x-3">
                            <div className="hidden sm:flex items-center space-x-2">
                <span className="text-sm text-gray-300">
                  {user?.name ?? "Welcome back!"}
                </span>

                            </div>


                            <div className="w-8 h-8 bg-yellow-600 rounded-full flex items-center justify-center">
                        <span className="text-white text-sm font-medium">
                            {user?.name?.charAt(0).toUpperCase() || "U"}
                </span>{" "}
                            </div>

                        </div>
                    </div>
                </header>

                {/* Page Content */}
                <main className="flex-1 overflow-x-hidden overflow-y-auto bg-gray-900 p-4">
                    <div className="max-w-7xl mx-auto">
                        <Outlet/>
                    </div>
                </main>
            </div>

            {/* Mobile sidebar overlay */}
            {sidebarOpen && (
                <div
                    className="fixed inset-0 z-40 lg:hidden"
                    onClick={() => setSidebarOpen(false)}
                >
                    <div className="fixed inset-0 bg-gray-600 bg-opacity-75"></div>
                </div>
            )}
        </div>
    );
};

export default DashboardLayout;
